import { gql, TypedDocumentNode } from '@apollo/client'
import type {
  PayslipsTabPayslipsQuery,
  PayslipsTabPayslipsQueryVariables
} from './__generated__/PayslipsTabPayslipsQuery'

export const payslipsTabPayslipsQuery: TypedDocumentNode<
  PayslipsTabPayslipsQuery,
  PayslipsTabPayslipsQueryVariables
> = gql`
  query PayslipsTabPayslipsQuery(
    $employeeId: ID!
    $wageStart: Date
    $wageEnd: Date
    $calculationStart: Date
    $calculationEnd: Date
  ) {
    payslips(
      employeeId: $employeeId
      wageStart: $wageStart
      wageEnd: $wageEnd
      calculationStart: $calculationStart
      calculationEnd: $calculationEnd
    ) {
      creationDate
      key
      pdfUrl
      wageDate
    }
  }
`
